import { withStyles } from '@mui/styles';

import AssetBalances from './assetBalances';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(AssetBalances);